export const WEBSITE_NAME = "kalyanawaran";
export const COPYRIGHT_SYMBOL = "Copyright © 2020";
export const RIGHT_RESERVED = "All rights reserved";
export const COMPANY_NAME = "Atdoor";
export const COMPANY_URL = "https://www.atdoor.co.in/";
